import styled, { css } from 'styled-components';
import { pxToRem } from 'utils/ui';
export var DRAG_HANDLE_HOVER_CLASSNAME = 'drag-handle-hover-trigger';
var DragHandle = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isDragging';
  }
}).withConfig({
  displayName: "DragHandle",
  componentId: "sc-1uk9qum-0"
})(["color:", ";width:", ";height:", ";padding:", " ", ";opacity:0.5;", " &:hover,&:focus,.", ":hover &{color:", ";opacity:", ";}&:focus:not(.focus-visible){outline:none;}&.focus-visible{outline:3px solid currentColor;outline-offset:3px;}&::after{content:'';display:block;width:3px;height:3px;border-radius:100%;background-color:currentColor;box-shadow:5px 0 0 0 currentColor,0 6px 0 0 currentColor,5px 6px 0 0 currentColor,0 12px 0 0 currentColor,5px 12px 0 0 currentColor;}"], function (p) {
  return p.theme.text;
}, pxToRem(16), pxToRem(21), pxToRem(3), pxToRem(4), function (p) {
  return p.isDragging && css(["color:", ";opacity:1;"], function (p) {
    return p.theme.links;
  });
}, DRAG_HANDLE_HOVER_CLASSNAME, function (p) {
  return p.theme.links;
}, function (p) {
  return p.theme.textDimStrength;
});
export default DragHandle;